import HttpService from "./http.service";

class NotificationService extends HttpService {
  public uri = "timeclocks_manager";
}

export const notificationService = new NotificationService();
